<template>
  <Menu as="div" class="ml-3 relative">
    <MenuButton
      class=" rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 "
      :class="{
        'focus:ring-untitled-gray-500 bg-white': !kintzApp,
        'focus:ring-kintz-primary-2 text-kintz-primary-4 hover:text-kintz-primary-2 focus:text-kintz-primary-2': kintzApp
      }"
    >
      <span class="sr-only">View Apps</span>
      <ViewGridIcon
        class="h-6 w-6 "
        :class="{
          'text-untitled-gray-400 hover:text-untitled-gray-500 focus:ring-untitled-gray-500': !kintzApp,
        }"
        aria-hidden="true"
      />
    </MenuButton>
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="z-10 origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1  ring-1  ring-opacity-5 focus:outline-none"
        :class="{
          'ring-black bg-white': !kintzApp,
          'ring-kintz-primary-3 bg-kintz-primary-1': kintzApp
        }"
      >
        <!-- Use the `active` state to conditionally style the active item. -->
        <MenuItem
          v-for="client in apps"
          :key="client.link"
          as="template"
          v-slot="{ active }"
          class="block px-4 py-2 text-sm"
          :class="[
            // active ? 'bg-untitled-gray-100' : '',
            // ' text-untitled-gray-700',
            {
              'bg-untitled-gray-100': active && !kintzApp,
              'text-untitled-gray-700': !kintzApp && !active,
              'bg-kintz-primary-1 text-kintz-primary-2': active && kintzApp,
              'text-kintz-primary-4 bg-kintz-primary-3': !active && kintzApp,
            }
          ]"
        >
          <a
            :href="client.link"
            target="_blank"
            class="block px-4 py-2 text-sm "
            :class="[
              {
                'bg-untitled-gray-100': active && !kintzApp,
                'text-untitled-gray-700': !kintzApp && !active,
                'bg-kintz-primary-1 text-kintz-primary-2': active && kintzApp,
                'text-kintz-primary-4 bg-kintz-primary-3': !active && kintzApp,
              }
            ]"
          >
            <img
              class="w-5 inline-block"
              :src="client.cover_photo"
              alt="App Menu"
            />
            {{ client.name }}
          </a>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { ViewGridIcon } from "@heroicons/vue/outline";
import { defineProps } from "vue";

defineProps({
  apps: {
    required: true,
  },
  kintzApp: {
    type: Boolean,
    default: false,
  }
});
</script>
